/* eslint-disable react/no-danger */
/* eslint-disable no-undef */
import React from 'react';
import { observable, action } from 'mobx';
import { makeApi, URLS } from 'Utils/apiUtil';
import { observer } from 'mobx-react';
import Utils from 'Utils/utils';
import userDetail from 'Stores/userDetail';
import { confirmationPopupState } from 'Components/common/confirmationPopup';

import conciergeSampleCsvFile from 'Assets/csv/Concierge_Sample_File.csv';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
import Button from './Button';

class ConciergeListUploadState {
  @observable showCreateList = false;

  @observable getListLoading = false;

  @observable isActiveInprogressList = false;

  @observable conciergeListEntries = [];

  @observable callBack = () => {};

  @action
  setGetListLoading = (val = false) => {
    this.getListLoading = val;
  };

  @action
  setIsActiveInprogressList = (val = false) => {
    this.isActiveInprogressList = val;
  };

  @action
  setConciergeListEntries = (val = []) => {
    this.conciergeListEntries = val;
  };

  @action
  setShowCreateList = val => {
    this.showCreateList = val;
    if (val)
      document.getElementsByTagName('body')[0].classList.add('scrollHidden');
    else
      document.getElementsByTagName('body')[0].classList.remove('scrollHidden');
  };

  saveNewList = (listName, entries, callback = () => {}) => {
    const config = {
      url: URLS.concierge.createList,
      method: 'POST',
      data: {
        listName,
        input: entries,
      },
    };

    makeApi(config)
      .then(response => {
        if (response && response.status === 200 && response.data !== undefined)
          callback(response.data);
        else callback(null);
      })
      .catch(error => {
        console.log('saveNewList error ', error);
      });
  };

  @action
  getConciergeList = () => {
    const config = {
      url: URLS.concierge.getLists,
      method: 'GET',
    };
    this.getListLoading = true;
    makeApi(config)
      .then(response => {
        if (
          response &&
          response.status === 200 &&
          response.data !== undefined
        ) {
          const { list, isActiveInProgress = false } = response.data;
          this.setConciergeListEntries(list);
          this.setIsActiveInprogressList(isActiveInProgress);
        }

        this.getListLoading = false;
      })
      .catch(error => {
        this.getListLoading = false;
        console.log('getConciergeList error ', error);
      });
  };
}
const conciergeListUploadState = new ConciergeListUploadState();

const ConciergeListUploadPopup = observer(props => {
  const ERROR_FIELD = {
    ENTER_LIST_NAME: 'ENTER_LIST_NAME',
    UPLOAD_NEW_LIST: 'UPLOAD_NEW_LIST',
  };

  const maxAllowedEntries = 100;
  const [selectedListName, setSelectedListName] = React.useState('');

  const [errorToolMsg, showErrorToolMsg] = React.useState('');
  const [inputValidation, setInputValidation] = React.useState({});
  const [uploadedEntries, setUploadedEntries] = React.useState('');
  const [uploadedFileName, setUploadedFileName] = React.useState('');

  const [fileUpload, setFileUpload] = React.useState(true);

  const [isLoading, setIsLoading] = React.useState(false);

  const { userInfo } = userDetail;
  const { conciergeCredits } = userInfo;

  const changeInputVal = value => {
    showErrorToolMsg('');
    if (inputValidation[ERROR_FIELD.ENTER_LIST_NAME] !== null) {
      const newValObj = Utils.copyObjectWithoutReference(inputValidation);
      delete newValObj[ERROR_FIELD.ENTER_LIST_NAME];
      setInputValidation(newValObj);
    }
    setSelectedListName(value);
  };

  const closeListPopup = () => {
    conciergeListUploadState.setGetListLoading(false);
    conciergeListUploadState.setShowCreateList(false);
  };

  const submitAction = e => {
    if (e.charCode === 13) getContacts();
  };

  const onFileChange = async e => {
    const callBack = data => {
      if (data !== '' && data === 'error') {
        showErrorToolMsg(
          `Maximum number of rows allowed is ${maxAllowedEntries} / List.`,
        );
      } else {
        const { fname = '', entries = [] } = data || {};
        if (entries.length === 0) {
          showErrorToolMsg('Uploaded list has no valid rows.');
        } else {
          if (inputValidation[ERROR_FIELD.UPLOAD_NEW_LIST] !== null) {
            const newValObj = Utils.copyObjectWithoutReference(inputValidation);
            delete newValObj[ERROR_FIELD.UPLOAD_NEW_LIST];
            setInputValidation(newValObj);
          }

          setUploadedFileName(fname);
          setUploadedEntries(entries);
        }
      }
      setTimeout(function() {
        setFileUpload(false);
      }, 0);
      setTimeout(function() {
        setFileUpload(true);
      }, 50);
    };
    Utils.uploadCsv(e, callBack, true, maxAllowedEntries);
  };

  const triggerUpload = e => {
    setInputValidation({});
    const validationObj = {};
    if (selectedListName === '') validationObj[ERROR_FIELD.ENTER_LIST_NAME] = 1;

    if (Object.keys(validationObj).length === 0) {
      showErrorToolMsg('');
      // eslint-disable-next-line no-undef
      document.getElementById('uploadConciergeListCsv').click();
    } else {
      setInputValidation(validationObj);
    }
  };

  const saveNewList = () => {
    showErrorToolMsg('');
    setInputValidation({});
    const validationObj = {};
    if (selectedListName === '') validationObj[ERROR_FIELD.ENTER_LIST_NAME] = 1;
    if (uploadedEntries.length === 0)
      validationObj[ERROR_FIELD.UPLOAD_NEW_LIST] = 1;

    if (Object.keys(validationObj).length === 0 && uploadedEntries.length > 0) {
      setIsLoading(true);
      const saveRequestCallback = response => {
        setIsLoading(false);
        if (response) {
          const { statusCode = null } = response;
          console.log('response ', statusCode);
          conciergeListUploadState.setShowCreateList(false);
          if (statusCode === 200) {
            confirmationPopupState.setPopupValues({
              title: 'Concierge Services - New Request',
              content:
                'Thank you for placing your request. You will receive an email with the link to download the enriched contact list soon. ',
              actionBtnText: 'OK',
              callback: () => {},
              needCancelBtn: false,
              showCloseBtn: false,
            });
            confirmationPopupState.setShowPopup(true);
            conciergeListUploadState.getConciergeList();
          } else if (statusCode === 203) {
            confirmationPopupState.setPopupValues({
              title: '',
              content:
                '<br />Sorry, you don’t have enough concierge credits to submit a new request! Write to us now at <a href="mailto:success@adapt.io" target="_blank">success@adapt.io</a> and get a credit top up immediately.',
              actionBtnText: 'OK',
              callback: () => {},
              needCancelBtn: false,
              showCloseBtn: false,
            });
            confirmationPopupState.setShowPopup(true);
          } else if (statusCode === 204) {
            confirmationPopupState.setPopupValues({
              title: '',
              content:
                '<br />Another request is being processed currently. Kindly wait for it to complete to place the next request.',
              actionBtnText: 'OK',
              callback: () => {},
              needCancelBtn: false,
              showCloseBtn: false,
            });
            confirmationPopupState.setShowPopup(true);
          } else {
            confirmationPopupState.setPopupValues({
              title: '',
              content:
                '<br />Something went wrong. Please try again. If the problem persists, please write to us at <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a>',
              actionBtnText: 'OK',
              callback: () => {},
              needCancelBtn: false,
              showCloseBtn: false,
            });
            confirmationPopupState.setShowPopup(true);
          }
        }
      };
      conciergeListUploadState.saveNewList(
        selectedListName,
        uploadedEntries,
        saveRequestCallback,
      );
    } else {
      setInputValidation(validationObj);
    }
  };

  React.useEffect(() => {
    if (!conciergeListUploadState.showCreateList) {
      setSelectedListName('');
      showErrorToolMsg('');
      setInputValidation({});
      showErrorToolMsg('');
      setUploadedEntries([]);
      setUploadedFileName('');
      setIsLoading(false);
    }
  }, [conciergeListUploadState.showCreateList]);

  return conciergeListUploadState.showCreateList ? (
    <>
      <div className="concierge-list-create-popup common-popup">
        <div className="popup-wrap">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => closeListPopup()}
          >
            <CloseIcon />
          </div>
          <div className="title">
            Submit New Request
            <div className="short-info">
              Upload the list of contacts along with their email
              addresses/LinkedIn URL. A list can have a maximum of{' '}
              {maxAllowedEntries} contacts. (
              <a
                className="sample-csv"
                href={conciergeSampleCsvFile}
                download=""
              >
                Download Sample List
              </a>
              )
            </div>
          </div>
          <div className="popup-content-wrap">
            <div className="verifyed-info-wrapper">
              <InfoIcon width={18} height={18} className="title-info-icon" />

              <div className="verifyed-info">
                Concierge credits remaining:{' '}
                <b>{Utils.usNumberFormat(conciergeCredits)}</b>
              </div>
            </div>
            <div className="create-list-input-wrap">
              <input
                id="createUpdateListbox"
                className={`input-box ${
                  inputValidation[ERROR_FIELD.ENTER_LIST_NAME] !== undefined
                    ? 'error-border'
                    : ''
                }`}
                type="text"
                placeholder="List name"
                value={selectedListName}
                onChange={e => changeInputVal(e.currentTarget.value)}
                onKeyPress={submitAction}
                autoComplete="off"
              />
            </div>
            <div className="csv-upload-wrapper upload-csv">
              {fileUpload && (
                <input
                  id="uploadConciergeListCsv"
                  className="custom-file-input"
                  type="file"
                  accept=".csv"
                  onChange={onFileChange}
                />
              )}
              <div
                className={`upload-btn ${
                  inputValidation[ERROR_FIELD.UPLOAD_NEW_LIST] !== undefined
                    ? 'error-border'
                    : ''
                }`}
                onClick={e => triggerUpload(e)}
              >
                Choose a file
              </div>
              {uploadedFileName !== '' && (
                <div className="uploaded-file-name">{uploadedFileName}</div>
              )}
            </div>
            <div className={`${errorToolMsg !== '' ? 'show' : ''} error-text`}>
              {errorToolMsg}
            </div>
          </div>
          <div className="popup-action-wrap">
            <Button
              btnText="Submit"
              icon={false}
              iconName=""
              type="button"
              className={`popup-action-btn positive-btn${
                isLoading ? ' loading' : ''
              }`}
              loader={isLoading}
              click={() => saveNewList()}
            />
            <div className="popup-action-btn" onClick={() => closeListPopup()}>
              Cancel
            </div>
          </div>
        </div>
      </div>
      <div className="common-popup-mask" onClick={() => closeListPopup()} />
    </>
  ) : (
    ''
  );
});

export { ConciergeListUploadPopup, conciergeListUploadState };
export default ConciergeListUploadPopup;
